/* requires:
polyfill.js
*/

const generateEmarsysUrl = (formFields, formId) => {
  const emarsysFormId = `f=${formId}&`,
    inp_1 = formFields.first_name ? `inp_1=${formFields.first_name}&` : '',
    inp_2 = formFields.last_name ? `inp_2=${formFields.last_name}&` : '',
    inp_3 = formFields.email ? `inp_3=${formFields.email}&` : '',
    inp_15 = formFields.phone ? `inp_15=${formFields.phone}&` : '',
    inp_17 = formFields.title ? `inp_17=${formFields.title}&` : '',
    inp_18 = formFields.company ? `inp_18=${formFields.company}&` : '',
    inp_2718 = formFields['00N1T00000AXeke'] ? `inp_2718=${formFields['00N1T00000AXeke']}&` : '',
    inp_2719 = formFields['00N1T00000AXelN'] ? `inp_2719=${formFields['00N1T00000AXelN']}&` : '',
    inp_2720 = formFields['00N1T00000AXeke'] ? `inp_2720=${formFields['00N1T00000AXeke']}&` : '',
    inp_2721 = formFields['00N1T00000AXel8'] ? `inp_2721=${formFields['00N1T00000AXel8']}&` : '',
    inp_2723 = formFields.lead_source ? `inp_2723=${formFields.lead_source}&` : '',
    inp_2725 = formFields.status ? `inp_2725=${formFields.status}&` : '',
    inp_2726 = formFields['00N1T00000AXel3'] ? `inp_2726=${formFields['00N1T00000AXel3']}&` : '',
    inp_2727 = formFields.leaduuid ? `inp_2727=${formFields.leaduuid}&` : '',
    inp_2728 = formFields['00N1T00000AXef3'] ? `inp_2728=${formFields['00N1T00000AXef3']}&` : '',
    inp_2777 = formFields['00N1T00000Axl4O'] ? `inp_2777=${formFields['00N1T00000Axl4O']}&` : '',
    inp_2809 = formFields.state ? `inp_2809=${formFields.state}&` : '',
    inp_17832 = formFields['00N1T00000AXfJP'] ? `inp_17832=${formFields['00N1T00000AXfJP']}&` : '',
    inp_17833 = formFields['00N1T00000AXef2'] ? `inp_17833=${formFields['00N1T00000AXef2']}&` : '',
    inp_18500 = formFields['00N1T00000AXfJU'] ? `inp_18500=${formFields['00N1T00000AXfJU']}&` : '',
    inp_24247 = formFields['00N5000000AUxxH'] ? `inp_24247=${formFields['00N5000000AUxxH']}&` : '',
    inp_24248 = formFields['00N50000001KVIK'] ? `inp_24248=${formFields['00N50000001KVIK']}&` : '';

  const emarsysFormUrl =
    'https://link.theuniversityplatform.com/u/register.php?CID=817427910&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&' +
    emarsysFormId +
    inp_1 +
    inp_2 +
    inp_3 +
    inp_15 +
    inp_17 +
    inp_18 +
    inp_2718 +
    inp_2719 +
    inp_2720 +
    inp_2721 +
    inp_2723 +
    inp_2725 +
    inp_2726 +
    inp_2727 +
    inp_2728 +
    inp_2777 +
    inp_2809 +
    inp_17832 +
    inp_17833 +
    inp_18500 +
    inp_24247 +
    inp_24248;
  return emarsysFormUrl;
};

const leadForm = {
  init: function (formSetting) {
    const { theForm } = formSetting;
    if (!theForm) {
      return false;
    }
    this.validateOnBlur(theForm);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type=submit]') || theForm.querySelector('input[type=submit]');
    submitBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const isFormValid = leadForm.isFormValid(theForm);
        if (!isFormValid) {
          theForm.querySelector('.validation-msg').classList.remove('d-none');
          return false;
        } else {
          leadForm.submit(formSetting);
        }
      },
      true
    );
  },
  validateOnBlur: function (theForm) {
    if (!theForm) {
      return false;
    }
    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      const type = field.type;
      if (type === 'email') {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            const re =
              /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(x)) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      } else if (type === 'tel') {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
            if (!re.test(x)) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      } else {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            if (!x || x.trim() == '') {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      }
    }
  },
  isFormValid: function (theForm) {
    if (!theForm) {
      return false;
    }
    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const type = field.type;
      if (type === 'email') {
        const x = field.value;
        const re =
          /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(x)) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      } else if (type === 'tel') {
        const x = field.value;
        const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
        if (!re.test(x)) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      } else {
        const x = field.value;
        if (!x || x.trim() == '') {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      }
    }
    return isFormValid;
  },
  submit: function (formSetting) {
    const { theForm, emarsysFormId } = formSetting;
    const submitBtn = theForm.querySelector('button[type=submit]');

    const readCookie = (name) => {
      let nameEQ = escape(name) + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
      }
      return null;
    };
    const uuid = () => {
      // generates leaduuid - from Jerome
      function _p8(s) {
        var p = (Math.random().toString(16) + '000000000').substr(2, 8);
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
      }
      return _p8() + _p8(true) + _p8(true) + _p8();
    };

    const leaduuid = uuid();
    const lgr = readCookie('lgr') || '';
    const referringUrl = document.referrer || '';
    const sourceUrl = window.location.href || '';
    const sourceDomain = 'https://' + window.location.host || '';
    const adwordsLead = readCookie('adwordsLead') || '';
    const facebookLead = readCookie('facebookLead') || '';
    const bingLead = readCookie('bingLead') || '';
    const clientID = readCookie('_ga') ? readCookie('_ga').split('.').slice(2).join('.') : '';

    theForm.querySelector('input.lgr').value = lgr;
    theForm.querySelector('input.refurl').value = referringUrl;
    theForm.querySelector('input.source_url').value = sourceUrl;
    theForm.querySelector('input.source_domain').value = sourceDomain;
    theForm.querySelector('input.leaduuid').value = leaduuid;
    theForm.querySelector('input.gclid').value = adwordsLead;
    theForm.querySelector('input.facebookLead').value = facebookLead;
    theForm.querySelector('input.bingLead').value = bingLead;
    theForm.querySelector('input.clientID').value = clientID;

    const hiddenFields = [];
    const formRawData = new FormData(theForm);

    // generate form fields data for submission
    const fields = [...hiddenFields];
    for (let pair of formRawData.entries()) {
      // console.log(pair[0]+ ', '+ pair[1]);
      const keyValues = {
        name: pair[0],
        value: pair[1],
      };
      fields.push(keyValues);
    }

    // form fields key-value pairs
    const formFields = fields.reduce((fieldObject, field) => {
      fieldObject[field.name] = field.value;
      return fieldObject;
    }, {});

    // setting the return URL dynamically per form
    theForm.querySelector('input[name="retURL"]').value = generateEmarsysUrl(formFields, emarsysFormId);

    const formActionUrl = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

    submitBtn.innerHTML = 'Submitting...';

    theForm.action = formActionUrl;

    // a simple theForm.submit() doesn't work because we have name=submit in one of the input which override the submit() function on the form
    const submitFormFunction = Object.getPrototypeOf(theForm).submit;
    submitFormFunction.call(theForm);

    submitBtn.innerHTML = 'Submit';
  },
};

// This is how to initialize the form processor script within the page that uses this
// const formSetting = {
//   theForm: document.querySelector('form.leadform'),
//   emarsysFormId: 2680,
// }
// leadForm.init(formSetting)
